import {  qspost } from '@/config/axios';

//投注列表
export const getList = data => qspost("request?", data ,"game_tz_log");